import { Text } from '@mantine/core';
import { AnimatePresence, motion } from 'framer-motion';
import { type FC, useEffect, useState } from 'react';
import businessWebsiteInputArrow from '@/srcV2/assets/business-website-input-arrow.svg';
import { useHostContext } from '@/srcV2/context/HostContext.tsx';

type Props = {
	isDismissed: boolean;
};

const BusinessWebsiteInput: FC<Props> = ({ isDismissed }) => {
	const { localization } = useHostContext();
	const [hasPageInteracted, setHasPageInteracted] = useState(false);
	const note = localization.translate(
		'vibeCreator',
		'createNewAIReceptionist.note'
	);

	useEffect(() => {
		if (isDismissed || hasPageInteracted) {
			return;
		}

		const handlePageInteraction = () => {
			setHasPageInteracted(true);
		};

		window.addEventListener('keydown', handlePageInteraction);
		window.addEventListener('pointerdown', handlePageInteraction);
		window.addEventListener('wheel', handlePageInteraction);

		return () => {
			window.removeEventListener('keydown', handlePageInteraction);
			window.removeEventListener('pointerdown', handlePageInteraction);
			window.removeEventListener('wheel', handlePageInteraction);
		};
	}, [hasPageInteracted, isDismissed]);

	return (
		<AnimatePresence>
			{!isDismissed && !hasPageInteracted && (
				<motion.div
					animate={{ opacity: 1, y: 0 }}
					className="pointer-events-none absolute left-0 right-0 top-full mt-3 flex w-full items-center justify-start"
					data-testid="enter-business-website-here"
					exit={{ opacity: 0, y: -6 }}
					initial={{ opacity: 0, y: 10 }}
					transition={{
						delay: 5,
						duration: 0.25,
						ease: 'easeOut'
					}}
				>
					<div className="flex ml-[20%]">
						<img
							alt=""
							aria-hidden="true"
							className="h-[42px] w-[41px]"
							src={businessWebsiteInputArrow}
						/>

						<Text
							className='relative text-blue-500  whitespace-pre-line leading-[1.25] [font-family:"Architects_Daughter",cursive]'
							data-testid="enter-business-website-here-text"
							size="xl"
						>
							{note}
						</Text>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default BusinessWebsiteInput;
